import React, { useState, useRef } from 'react';
import classNames from 'classnames';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import {ShippingLinesService} from '../service/ShippingLinesService';
import {useMountEffect} from "primereact";
import {isNullOrUndef} from "chart.js/helpers";

export const ShippingLines = () => {

    let emptyShippingLine = {
        id: null,
        title: '',
        url: ''
    };

    const [shippingLines, setShippingLines] = useState(null);
    const [shippingLineDialog, setShippingLineDialog] = useState(false);
    const [deleteShippingLineDialog, setDeleteShippingLineDialog] = useState(false);
    const [shippingLine, setShippingLine] = useState(emptyShippingLine);
    const [selectedShippingLine, setSelectedShippingLine] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const toast = useRef(null);
    const dt = useRef(null);
    const [loading, setLoading] = useState(true);
    const shippingLineService = new ShippingLinesService();


    useMountEffect(() => {
        shippingLineService.getShippingLines()
            .then(data => {
                setShippingLines(data);
                setLoading(false);
            });
    });

    const openNew = () => {
        setShippingLine(emptyShippingLine);
        setSubmitted(false);
        setShippingLineDialog(true);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setShippingLineDialog(false);
    }

    const hideDeleteShippingLineDialog = () => {
        setDeleteShippingLineDialog(false);
    }

    const saveShippingLine = () => {
        setSubmitted(true);

        if (shippingLine.title.trim()) {
            let _shippingLines = [...shippingLines];
            let _ShippingLine = {...shippingLine};

            shippingLineService.saveShippingLine(_ShippingLine)
                .then(data => {
                    if (shippingLine.id) {
                        const index = findIndexById(shippingLine.id);
                        _shippingLines[index] = data;
                        toast.current.show({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Shipping Line Updated',
                            life: 3000
                        });
                    } else {
                        _shippingLines.push(data);
                        toast.current.show({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Shipping Line Created',
                            life: 3000
                        });
                    }
                    setShippingLines(_shippingLines);
                    setShippingLineDialog(false);
                    setShippingLine(emptyShippingLine);
                })
                .catch(error => {
                    toast.current.show({severity: 'error', summary: 'Error', detail: error, life: 3000});
                });
        }
    }

    const editShippingLine = (shippingLine) => {
        setShippingLine({ ...shippingLine });
        setShippingLineDialog(true);
    }

    const confirmDeleteShippingLine = (shippingLine) => {
        setShippingLine(shippingLine);
        setDeleteShippingLineDialog(true);
    }

    const deleteShippingLine = () => {
        shippingLineService.deleteShippingLine(shippingLine.id)
            .then(data => {
                if(!isNullOrUndef(data) && !data.success) {
                    setDeleteShippingLineDialog(false);
                    setShippingLine(emptyShippingLine);
                    toast.current.show({severity: 'error', summary: 'Error', detail: data.errorMessage, life: 3000});
                } else {
                    let _shippingLines = shippingLines.filter(val => val.id !== shippingLine.id);
                    setShippingLines(_shippingLines);
                    setDeleteShippingLineDialog(false);
                    setShippingLine(emptyShippingLine);
                    toast.current.show({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'ShippingLine Deleted',
                        life: 3000
                    });
                }
            })
            .catch(error => {
                toast.current.show({severity: 'error', summary: 'Error', detail: error, life: 3000});
            });
    }

    const findIndexById = (id) => {
        let index = -1;
        for (let i = 0; i < shippingLines.length; i++) {
            if (shippingLines[i].id === id) {
                index = i;
                break;
            }
        }

        return index;
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _shippingLine = { ...shippingLine };
        _shippingLine[`${name}`] = val;

        setShippingLine(_shippingLine);
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="New" icon="pi pi-plus" className="p-button-success p-mr-2 p-mb-2" onClick={openNew} />
            </React.Fragment>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text p-button-sm"
                        title={'Edit'} onClick={() => editShippingLine(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger p-button-text p-button-sm"
                        title={'Delete'} onClick={() => confirmDeleteShippingLine(rowData)} />
            </div>
        );
    }

    const header = (
        <div className="table-header">
            <h5 className="p-m-0">Manage Shipping Lines</h5>
        </div>
    );

    const shippingLineDialogFooter = (
        <>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={saveShippingLine} />
        </>
    );
    const deleteShippingLineDialogFooter = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteShippingLineDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteShippingLine} />
        </>
    );

    return (
        <div className="p-grid crud-demo">
            <div className="p-col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="p-mb-4 p-toolbar" left={leftToolbarTemplate}/>

                    <DataTable ref={dt} value={shippingLines} selection={selectedShippingLine} onSelectionChange={(e) => setSelectedShippingLine(e.value)}
                               dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive" loading={loading}
                               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                               currentPageReportTemplate="Showing {first} to {last} of {totalRecords} shipping Lines"
                               emptyMessage="No Shipping Line found." header={header}>
                        <Column field="title" header="Title" sortable/>
                        <Column field="url" header="URL" sortable/>
                        <Column body={actionBodyTemplate} bodyStyle={{textAlign: 'right'}}/>
                    </DataTable>

                    <Dialog visible={shippingLineDialog} style={{ width: '450px' }} header="Shipping Line Details" modal className="p-fluid" footer={shippingLineDialogFooter} onHide={hideDialog}>
                        <div className="p-field">
                            <label htmlFor="title">Title</label>
                            <InputText id="title" value={shippingLine.title} onChange={(e) => onInputChange(e, 'title')}
                                       required autoFocus className={classNames({ 'p-invalid': submitted && !shippingLine.title })} />
                            {submitted && !shippingLine.title && <small className="p-invalid">Title is required.</small>}
                        </div>
                        <div className="p-field">
                            <label htmlFor="url">URL</label>
                            <InputText id="url" value={shippingLine.url} onChange={(e) => onInputChange(e, 'url')} />
                        </div>
                    </Dialog>

                    <Dialog visible={deleteShippingLineDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteShippingLineDialogFooter} onHide={hideDeleteShippingLineDialog}>
                        <div className="confirmation-content">
                            <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                            {shippingLine && <span>Are you sure you want to delete <b>{shippingLine.title}</b>?</span>}
                        </div>
                    </Dialog>
                </div>
            </div>
        </div>
    );
}
